import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCartas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('cartas', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
